// eslint-disable-next-line spaced-comment
/// <reference types="@emotion/react/types/css-prop" />

import React from 'react';

import {
  Container,
  IconContainer,
  TextContainer,
  NotificationMessage,
  UnreadDot,
  TimeLabel,
} from './NotificationItem.styles';

interface ImageElement {
  src: string;
  alt: string;
}

interface NotificationItemProps {
  message?: string;
  link?: string;
  read?: boolean;
  time?: string;
  /** Pass in `iconComponent` (ex. `<GiftIcon />`) or `iconImage` (ex. `{src: Gift, alt: 'gift-icon'}`); if both passed, both with display */
  iconComponent?: React.ReactElement;
  iconImage?: ImageElement;
  className?: string;
  [x: string]: unknown;
}

/**
 * `import NotificationItem from '@zola-ui/src/components/NotificationItem';`
 */
const NotificationItem: React.FC<NotificationItemProps> = ({
  message,
  link,
  read,
  time,
  iconComponent: IconComponent,
  iconImage,
  className,
  ...props
}) => {
  const iconSize = 24;
  return (
    <Container href={link} target="_self" className={className} {...props}>
      <IconContainer>
        {IconComponent && React.cloneElement(IconComponent, { width: iconSize, height: iconSize })}
        {iconImage && (
          <img
            src={iconImage.src}
            alt={iconImage.alt}
            css={{
              width: `${iconSize}px`,
              height: `${iconSize}px`,
            }}
          />
        )}
      </IconContainer>
      <TextContainer>
        <NotificationMessage>
          {message} {!read && <UnreadDot />}
        </NotificationMessage>
        <TimeLabel>{time}</TimeLabel>
      </TextContainer>
    </Container>
  );
};

export default NotificationItem;
